import ComingSoon from "components/ComingSoon";
import React from "react";

const Slack = () => {
  return <ComingSoon />;
};

export default Slack;
